import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class CustomerService {
  static customerCreate = async (bodydata) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/users/register",
        data: bodydata,

        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static customerDetails = async (rowsPerPage, page, serachTerm) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/users/admin/search",
        data: {
          filter: [{"keyword": serachTerm}],
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let customerDetail = response.data.data;
      return customerDetail;
    } catch (err) {
      throw err;
    }
  };

  static customerDetailsID = async (customerID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/users/admin/" + customerID,
        data: {
          filter: [],
          limit: 10,
          skip: 0,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let customerDetailID = response.data.data;

      return customerDetailID;
    } catch (err) {
      throw err;
    }
  };

  static customerDelete = async (customerID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/users/admin/" + customerID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static customerUpdate = async (customerID, values) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/users/admin/update/" + customerID,
        data: values,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static customerViewAll = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/users/admin/get/all/",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };
}
